// eslint-disable-next-line no-restricted-imports
import { createForm as createFForm } from 'final-form';
import { subscribedForms } from './utils.js';
import '@/js/libs/reatom-devtools/index.ts';
let i = 0;
// @ts-expect-error generics mismatch
export const createForm = (...a) => {
    const form = createFForm(...a);
    const name = `final-form#${(i += 1)}`;
    // wait to use the form in `Form` component, which may have more relevant name
    Promise.resolve().then(() => {
        if (DEVTOOLS && !subscribedForms.has(form)) {
            const state = DEVTOOLS.state(name, form.getState().values);
            form.subscribe(({ values }) => {
                state(values);
            }, { values: true });
            state.subscribe((newState) => form.initialize(newState));
            subscribedForms.add(form);
        }
    });
    return form;
};
